<template>
    <div class="instagram-page" >
        <div class="row" v-if="initialSetup === true && stats">
            <div class="col-md-12 mb-4" v-if="firstTime">
                <div class="alert alert-success">
                    Thank you for setting up your account! Your posts are being loaded at the moment and you will be able to view them in a few minutes.
                </div>
            </div>
            <div class="col-md-12 mb-4">
                <div class="d-flex justify-content-between align-items-center">
                    <div class="instagram-filters">
                        <date-range-picker
                            ref="picker"
                            :opens="pickerOptions.opens"
                            :locale-data="pickerOptions.localeDate"
                            :timePicker="false"
                            :timePicker24Hour="false"
                            :showWeekNumbers="false"
                            :showDropdowns="true"
                            :autoApply="true"
                            v-model="dateRange"
                            :linkedCalendars="true"
                            @update="getData()"
                        >
                            <div slot="input" slot-scope="picker" >
                                {{ picker.startDate | date }} - {{ picker.endDate | date }}
                            </div>
                        </date-range-picker>
                    </div>
                    <div>
                        <element-selector :elements="jwtHashtags" v-model="selectedHashtags" />
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="card">
                    <div class="card-header px-0 text-center">
                        <h5 class="header-title">TOTAL POSTS</h5>
                    </div>
                    <div class="card-body">
                        <div class="d-flex align-items-center justify-content-center">
                            <h2 class="number-l mb-0 mr-3">{{ stats.totalPosts }}</h2>
                            <i class="far fa-images brand-primary-gradient" style="font-size: 24px;"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="card">
                    <div class="card-header px-0 text-center">
                        <h5 class="header-title">TOTAL LIKES
                        </h5>
                    </div>
                    <div class="card-body">
                        <div class="d-flex align-items-center justify-content-center">
                            <h2 class="number-l mb-0 mr-3">{{ abbrNum(stats.totalLikes, 2) }}</h2>
                            <i class="far fa-heart gradient-danger" style="font-size: 24px;"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="card">
                    <div class="card-header px-0 text-center">
                        <h5 class="header-title">TOTAL COMMENTS</h5>
                    </div>
                    <div class="card-body">
                        <div class="d-flex align-items-center justify-content-center">
                            <h2 class="number-l mb-0 mr-3">{{ abbrNum(stats.totalComments, 2) }}</h2>
                            <i class="far fa-comment brand-primary-gradient" style="font-size: 24px;"></i>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-12">
                <instagram-progress v-if="postsStats" :data="postsStats"></instagram-progress>
            </div>

            <div class="col-md-12" v-if="posts.length">
                <div class="card overflow-hidden">
                    <div class="card-header d-none">
                        <h5 class="header-title">TOP POSTS</h5>
                    </div>
                    <div class="card-body p-0">
                        <div class="table-responsive posts-table">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>
                                        Post
                                    </th>
                                    <th>
                                        Caption
                                    </th>
                                    <th></th>
                                    <th></th>
                                    <th>
                                        Engagement
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="post in posts">
                                    <td>
                                        <a target="_blank" :href="'https://instagram.com/p/' + post.shortcode">
                                            <img style="max-width: 100px; max-height: 100px;" class="img-fluid" :src="post.imageUrl ? post.imageUrl : '/assets/img/missing_thumbnail.png'"/>
                                        </a>
                                    </td>
                                    <td class="text-left caption">
                                        <span class="caption-text">{{ post.caption.substring(0, 50) + (post.caption.length > 50 ? '...' : '') }}</span>
                                    </td>
                                    <td class="text-right">
                                        <i class="fa fa-heart"></i> {{ abbrNum(post.totalLikes, 1)}}
                                    </td>
                                    <td class="text-right">
                                        <i class="fa fa-comment"></i> {{ abbrNum(post.totalComments, 1) }}
                                    </td>
                                    <td class="text-right">
                                        {{ abbrNum(post.totalEngagement, 1) }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12" v-if="topics.length">
                <div class="card">
                    <div class="card-header">
                        <h5 class="header-title">Most Commmon Content</h5>
                    </div>
                    <div class="card-body">
                        <bar-chart v-if="topicsChart.data" style="height:400px;" :chartdata="topicsChart.data" :options="topicsChart.options"></bar-chart>

                    </div>
                </div>
            </div>
            <div class="col-md-12">
                <div class="card overflow-hidden">
                    <div class="card-header d-none">
                        <h5 class="header-title">TOP HASHTAGS</h5>
                    </div>
                    <div class="card-body p-0">
                        <div class="row">
                            <div class="col-md-8">
                                <wordcloud
                                    :data="words"
                                    nameKey="name"
                                    valueKey="value"
                                    :color="myColors"
                                    :rotate="{from: 0, to: 0, numOfOrientation: 2 }"
                                    :wordPadding="4"
                                    fontScale="n"
                                    :fontSize="[9, 34]"
                                    :showTooltip="false"
                                    :wordClick="clickTopHashtag"
                                >
                                </wordcloud>
                            </div>
                            <div class="col-md-4 highlight-col">
                                <p class="header-case text-center mt-2">
                                    Top Hashtags
                                </p>
                                <div class="table-responsive">
                                    <table class="w-100">
                                        <thead>
                                            <th></th>
                                            <th></th>
                                        </thead>
                                        <tbody>
                                            <tr v-for="hashtag in topTenHashtags">
                                                <td class="py-2">
                                                    <strong>#{{ hashtag.name }}</strong>
                                                </td>
                                                <td>
                                                    <span>{{hashtag.value}} <i class="fa fa-images"></i></span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-if="initialSetup === false">
            <instagram-settings />
        </div>
    </div>
</template>

<script>
import InstagramSettings from './InstagramSettings';
import InstagramMixin from "./InstagramMixin";
import ElementSelector from "./components/ElementSelector";
import Multiselect from 'vue-multiselect'
import DateRangePicker from 'vue2-daterange-picker'
import wordcloud from 'vue-wordcloud'
import InstagramService from '../../services/instagram-service'
import BarChart from '../charts/bar-chart'

export default {
    mixins: [InstagramMixin],
    components: {
        BarChart,
        DateRangePicker,
        wordcloud,
        Multiselect,
        InstagramSettings,
        ElementSelector
    },
    data() {
        return {
            firstTime: false,
            postsStats: null,
            posts: [],
            topics: [],
            stats: {},
            hashtags: [],
            stats: null,
            myColors: ['#00aef1', '#2d2d49', '#90919e'],
            defaultWords: [],
            words: [],
            topTenHashtags: [],
            topicsChart: {}
        }
    },
    watch: {
        selectedHashtags(newVal, oldVal) {
            this.getData();
        }
    },
    methods: {
        async completeSetup() {
            this.showSetupForm = false
            const data = {
                hashtags: this.hashtagsToFollow.map(hashtag => hashtag.title),
                locations: this.locationsToFollow.map(location => location.title),
                profile: this.profileToFollow
            }

            await InstagramService.settings.save({data})
        },
        clickTopHashtag(e) {
            console.log(e)
        },
        updateDefaultWords() {
            this.words = this.hashtags.map(hashtag => {
                return {
                    name: hashtag.title,
                    value: hashtag.totalMentions
                }
            })

            this.topTenHashtags = this.words.slice(0, 9)
        },
        updateTopicsChart() {
            this.topicsChart =  {
                data: {
                    labels: this.topics.slice(0, 10).map(topic => topic.title),
                    datasets: [
                        {
                            label: "Total",
                            backgroundColor: "#5eb3db",
                            data: this.topics.slice(0, 10).map(topic => topic.totalMentions)
                        }]
                },
                options: {
                    maintainAspectRatio: false,
                    responsive: true,
                    plugins: {
                        datalabels: {
                            // hide datalabels for all datasets
                            display: false
                        }
                    },
                    scales: {
                        xAxes: [{
                            maxBarThickness: 20,
                            stacked: true
                        }],
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    }
                }
            }
        },
        async getData(initial = false) {
            const params = {
                hashtags: [],
                from: this.dateRange.startDate,
                to: this.dateRange.endDate,
                sortBy: 'totalLikes',
                sortOrder: 'desc'
            }

            if(!this.selectedHashtags.length) {
                params.hashtags = this.jwtHashtags.join(',')
            } else {
                params.hashtags = this.selectedHashtags.join(',')
            }

            this.loading = true

            const stats = InstagramService.v2.stats.get(_.pick(params, 'from', 'to', 'hashtags'))
            const posts = InstagramService.v2.posts.index(Object.assign({}, params, {limit: 5, page: 1}))
            const topics = InstagramService.v2.topics.index(Object.assign({}, _.pick(params, 'from', 'to', 'hashtags'), {page: 1, limit: 10}))
            const hashtags = InstagramService.v2.hashtags.index(Object.assign({}, _.pick(params, 'from', 'to', 'hashtags'), {limit: 100}))
            const postsStats = InstagramService.v2.stats.get(Object.assign({type: 'overtime'}, _.pick(params, 'from', 'to', 'hashtags')))

            this.stats = (await stats)
            this.posts = (await posts).data
            this.topics = (await topics).data
            this.hashtags = (await hashtags).data
            this.postsStats = (await postsStats).data

            this.updateDefaultWords()
            this.updateTopicsChart()

            this.loading = false
        }
    },
    async mounted() {
        var url = new URL(location.href);
        if (url.searchParams.get("firstTime")) {
            this.firstTime = true;
        }
        if (this.initialSetup !== true) {
            const menuItems = document.getElementsByClassName('instagram-nav-item')

            for(var i = 1; i < menuItems.length; i++) {
                menuItems[i].style.display = 'none'
            }
            return
        }
        await this.getData(true)
    }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>